import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Web sitemizi yeniledikten sonra gelen randevu sayısı %180 arttı. Reklam yönetimleri çok şeffaf, her şey ölçülebilir.",
    name: "Selin Aksoy",
    role: "Klinik Sahibi · Beylikdüzü",
  },
  {
    quote:
      "Sipariş takip paneliyle hata oranımız neredeyse sıfırlandı. Müşterilerimiz nerede olduğunu görüyor.",
    name: "Mehmet Yıldız",
    role: "Restoran İşletmecisi",
  },
  {
    quote:
      "Instagram reklamlarımızı yönetmeye başladıklarından beri DM kutumuz dolup taşıyor. Profesyonel bir ekip.",
    name: "Ayşe Demir",
    role: "Butik Sahibi",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="ab-chip">Müşteri Yorumları</span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
            Müşterilerimiz <span className="ab-text-gradient">ne diyor</span>?
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="ab-card p-7 relative"
            >
              <Quote className="absolute top-6 right-6 h-8 w-8 text-[var(--ab-blue)]/15" />
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star
                    key={n}
                    className="h-4 w-4 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="mt-5 text-[var(--ab-navy)] leading-relaxed text-[0.98rem]">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 pt-5 border-t border-slate-100">
                <div className="font-display font-bold text-[var(--ab-navy)]">
                  {t.name}
                </div>
                <div className="text-xs text-slate-500 mt-0.5">{t.role}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
